import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["counter"]

  connect() {
    this.update()
  }

  update() {
    const checked = this.element.querySelectorAll("input[type='checkbox']:checked").length
    this.counterTargets.forEach((el) => { el.textContent = checked })
  }

  approveAll() {
    this.element.querySelectorAll("input[type='checkbox']").forEach((cb) => { cb.checked = true })
    this.update()
  }
}
